export var twitterCardSupportedTypes = {
    SUMMARY: 'summary',
    SUMMARY_LARGE_IMAGE: 'summary_large_image',
};
